import { twMerge } from "tailwind-merge";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  H3,
  H5,
  H6,
} from "@sellar-io/components";
import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { Icon } from "../../../components";
import { AddressFragment } from "../../../components/addressFragment/AddressFragment";
import { getInvoiceEmails } from "../../../utils/sellarHelpers";
import { CustomerUpdateInvoiceEmailModal } from "../CustomerUpdateInvoiceEmailModal";

export const BusinessConnectionInvoicingInfoCard = ({
  connection,
}: {
  connection: SupplierRelationshipGetResponseType;
}) => {
  const [customerUpdateActive, setCustomerUpdateActive] =
    useState<boolean>(false);

  return (
    <Card className="bg-white">
      <CardHeader
        className={twMerge("bg-white", "flex items-center justify-between")}
      >
        <H3>Invoicing info</H3>
        <Button
          color={"secondary"}
          onClick={() => setCustomerUpdateActive(true)}
        >
          <Icon icon={"PENCIL"} />
          Edit
        </Button>
      </CardHeader>
      <CardContent className={"grid gap-y-4 md:grid-cols-2"}>
        <div className={"flex flex-col"}>
          <H5>Invoice address</H5>
          <AddressFragment
            address={connection.Retailer.Business.InvoiceAddress}
          />
        </div>
        <div>
          <H5>Send invoices to</H5>
          <H6>
            {getInvoiceEmails({
              connection,
              buyer: connection.Retailer,
            }).join(", ")}
          </H6>
        </div>
      </CardContent>
      <CustomerUpdateInvoiceEmailModal
        active={customerUpdateActive}
        onDismiss={() => setCustomerUpdateActive(false)}
        connectionId={connection.id}
        invoiceEmails={getInvoiceEmails({ connection })}
      />
    </Card>
  );
};
